<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true">
    <rect x="8" y="8" width="13" height="13"/>
    <polyline points="5,15 3,15 3,3 15,3 15,5"/>
  </svg>
</template>
